import React, { useContext } from "react";
import { StudentContext } from "./StudentLayout";
import { CheckCircle2, Clock, BookOpen } from "lucide-react";

const MODULES = [
  { n: 1, title: "Introduction & Setup", desc: "Course overview, tools setup, learning roadmap" },
  { n: 2, title: "Fundamentals & Basics", desc: "Core concepts and foundational skills" },
  { n: 3, title: "Practical Training", desc: "Hands-on exercises and guided practice" },
  { n: 4, title: "Assignments", desc: "Apply your learning through real assignments" },
  { n: 5, title: "Live Project", desc: "Build a portfolio-worthy live project" },
  { n: 6, title: "Final Assessment", desc: "Capstone evaluation and feedback" },
];

const StudentCourses = () => {
  const { student } = useContext(StudentContext);
  if (!student) return <div className="text-slate-500">Loading...</div>;

  const progress = student.progress || 0;
  const completedModules = Math.floor((progress / 100) * MODULES.length);

  return (
    <div data-testid="student-courses">
      <div className="mb-8">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600 mb-2">My Courses</div>
        <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900">{student.selectedInternship}</h1>
        <p className="mt-1 text-slate-600">120-Hour Structured Internship · Online · Ongoing</p>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl p-6 mb-6">
        <div className="flex items-center justify-between mb-3">
          <span className="font-semibold text-slate-900">Course Progress</span>
          <span className="font-heading font-bold text-blue-600">{progress}%</span>
        </div>
        <div className="h-3 bg-slate-100 rounded-full overflow-hidden">
          <div className="h-full bg-blue-600 rounded-full transition-all" style={{ width: `${progress}%` }}></div>
        </div>
      </div>

      <div className="space-y-3">
        {MODULES.map((m, i) => {
          const done = i < completedModules;
          const active = i === completedModules;
          return (
            <div key={m.n} className={`bg-white border rounded-xl p-5 flex items-center gap-4 ${active ? "border-blue-300 shadow-sm" : "border-slate-200"}`}>
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center font-bold ${
                done ? "bg-green-100 text-green-700" : active ? "bg-blue-600 text-white" : "bg-slate-100 text-slate-500"
              }`}>
                {done ? <CheckCircle2 className="w-5 h-5" /> : m.n}
              </div>
              <div className="flex-1">
                <div className="font-heading font-semibold text-slate-900">Module {m.n}: {m.title}</div>
                <div className="text-sm text-slate-500">{m.desc}</div>
              </div>
              <div className="flex items-center gap-2 text-xs">
                {done && <span className="px-2 py-1 rounded-full bg-green-100 text-green-700 font-semibold">Completed</span>}
                {active && <span className="px-2 py-1 rounded-full bg-blue-100 text-blue-700 font-semibold">In Progress</span>}
                {!done && !active && <span className="px-2 py-1 rounded-full bg-slate-100 text-slate-500 font-semibold flex items-center gap-1"><Clock className="w-3 h-3" /> Locked</span>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StudentCourses;
